/*
 * @Author: edvardchen
 * @Date: 2017-09-27 18:14:11
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2021-01-18 14:43:15
 */

// @flow
import { type Store as ReduxStore, type Dispatch as ReduxDispatch } from 'redux';
import KdBigTReport from '../entries/kdarticle/bigTReport';
export type User = {
  coolBoot?: boolean,
  circleUserId?: string,
  head: string,
  nickname: string,
  type: number,
  uin: string,
  qbid: string,
  appid?: string,
  qbUserType: number,
  internal?: boolean,
  roleInCircle?: number,
  messageNum?: number,
  subscriptions?: {
    // 所有关注状态存放到这里，以次为准
    [string]: boolean,
  },
  recommandCircles?: *[], // 关注后的相关推荐
  recommandCirclesActive?: boolean, // 关注列表激活状态
  welfareInfo: {
    // 福利中心状态
    taskStart: boolean, // 是否领取任务
  },
  guid: string,
  gspObject?: Object,
  pushWelfare?: Object,
  RMPObject?: Object, // rmp平台用户信息
  followStatus?: boolean, // 看点图文 用户是否关注了这篇文章
  praiseStatus?: boolean, // 看点图文 用户是否对这篇图文点赞了
  kdBigTReportInstance?: KdBigTReport, // 看点大T上报实例 因为全局都要用且异步 没想到存在哪里更合适
};

export type Tag = {
  id: string,
  name: string,
  icon: string,
  descr?: string,
};

export type Answer = {
  datetime?: string,
  question?: *,
  id: string,
  circleId?: string,
  praiseNum?: number,
  praised?: boolean,
  commentNum?: number,
  user: {
    sFaceIcon: string,
    sNickname: string,
    fusionId?: string,
  },
  displayTime: string,
  viewNum: number,
  fields: *[],
};

type VoteItem = {
  iIndexNo: number,
  sText: string,
  iVoteNum: number,
  vUserInfo: *[],
  sVoteDesc: string,
  sUnvotePicUrl: string,
  sVotedPicUrl: string,
};
export type Vote = {
  postId: string,
  sCircleId: string,
  bRealName: boolean,
  vVoteItems: VoteItem[],
  iTotalUser: number,
  iTotalVote: number,
  iMyVoteItem: number,
  sVoteTitle: string,
  iVoteIndex: number,
  eVoteType: number,
};

export type PostInfo = {
  postId: string,
  circleId: string,
  valid: boolean,
  commentNum?: number,
  commentUrl?: string,
  editCommentUrl?: string,
  praiseNum?: number,
  praised?: boolean,
  vote?: Vote,
  pkId?: string,
  isVideo?: boolean,
  isDarkComments?: boolean,
  vid?: string,
  refPostSummary?: Object,
  refPcgCardInfo?: Object,
};

export type Article = {
  mergePageInfo?: *,
  showPushAttach?: boolean, // push地址向后兼容，非RN不露出夹带，需要这个字段来表示是否露出夹带
  zimeitiId?: string,
  guideTab: Object,
  thumbs: *[],
  abstract?: string,
  stSnapInfo: Object,
  mainSubjectId?: string,
  subjectId?: string,
  dataSrc?: string,
  avatar?: string,
  docId: string,
  url: string,
  time: string,
  from: string,
  fusionId?: string,
  liveRoomId?: number,
  title: string,
  sTitleLogo?: string,
  correlatedNews: Array<*>,
  contentFields: Array<{ type: string }>,
  relatedTags: Array<Tag>,
  bigAd?: *, // 正文大图广告
  adInCorrelated?: *, // 正文相关阅读广告
  explore?: *, // 精探数据
  mapExpand?: *, // 世界杯获取matchId
  relatedVote?: Object, // pk组件
  matchInfo?: Object, // 竞猜数据
  recommendMergeInfo?: Object, // 相关推荐精探合并数据
  WifiCorrelatedInfo?: Array<Object>, // wifi管家相关推荐数据
  contentHeight: number,
  tags?: *[],
  bInnerGuid?: boolean, // 是否是内部用户
  readingRate?: string, // 阅读比例
  readingTime?: string, // 阅读时长
  readingUsers?: number, // 当前在读人数
  preventDistrStatus?: boolean, // 是否屏蔽微视和快报导量
  LiveInfo?: Object, // now直播的数据
  guideReportInfo?: Object, // 导流上报数据
  feedbacks?: Object,
  ugGuideData?: Object, // 快报导流信息
  isUgGuide?: boolean, // 是否是导流,
  blueTipesInfo?: Object, // 疫情导流条
  tagDefaultInfo?: *[],
  imageVideo?: Object,
  AuthorRecommend?: Object, // 作者相关文章推荐
  correlateVideo?: Object,
  puin?: string,
  livingAccount?: Object,
  political?: boolean,
  novelData?: Object,
  isSogoExtreme?: boolean, // 是否是搜狗极速版浏览器
};

type UserInComent = {
  accountType: number,
  id: string,
  name: string,
  faceIcon: string,
  isAuthor: boolean,
};

export type ImageInComment = {
  sPicUrl: string,
  iHeight: number,
  iWidth: number,
};

export type CommentContent = {
  circleId?: string,
  id: string,
  user: UserInComent,
  content: string,
  images: ImageInComment[],
  time: string,
};

export type SubComments = {
  items: CommentContent[],
  total: number,
};

export type ImageInfo = {
  sPicUrl: string,
  iHeight: number,
  iWidth: number,
};

export type Comment = CommentContent & {
  praised?: boolean,
  praiseNum?: number,
  subComments?: SubComments,
  referComment?: CommentContent,
  bNicePost?: boolean,
  commentNum: number,
  eFrom: number,
  isNewComment?: boolean,
};

export type FETCH_STATUS = 'fetching' | 'error' | 'success';

export type AllComments = {
  lastId?: string,
  lastTime?: string,
  position?: number,
  items: Comment[],
  isEnd?: boolean,
  fetchStatus?: FETCH_STATUS,
  isVideo?: boolean,
  lastIndex?: number,
};

/* isomorphic location object */
export type Location = {
  query?: Object,
  hash?: string,
  pathname: string,
  isFastV?: boolean,
};

export type Question = {
  title: string,
  circleId: string,
  id: string,
  total: number,
};

export type Action = { type: string, payload?: * };

export type AllAnswers = {
  fetchStatus?: FETCH_STATUS,
  items: Array<Answer>,
  lastId?: string,
};

export type Special = {
  id: string,
  image?: string,
  introduction?: string,
  modules: Array<*>,
  title: string,
  type: number,
};

export type HonorInfoEx = {
  kolInfos: *,
  honorInfos: *,
};

export type MiniProgram = {
  config?: Object,
};

export type State = {
  entry: string, // 页面entry名称
  question?: Question,
  showNestedComments?: boolean,
  comment?: ?Comment,
  answer: Answer,
  allComments: AllComments,
  user: User,
  article: Article,
  postInfo: PostInfo,
  location: Location,
  currentChannel: string,
  title: string,
  hotComments: Comment[],
  apn: string,
  allAnswers: AllAnswers,
  special?: Special, // 专题
  apps: {
    wx?: boolean,
    qq?: boolean,
    qzone?: boolean,
    isOtherFt: boolean,
  },
  accuseModal: { show: boolean }, // 评论举报弹框
  inRN?: boolean,
  grayConfig?: Object, // 灰度策略
  honorInfoEx: HonorInfoEx,
  operateMsgs?: Object,
  ua?: string,
};

/* eslint-disable import/prefer-default-export */
export const initialState: State = {
  entry: '',
  answer: {
    displayTime: '',
    id: '',
    viewNum: 0,
    fields: [],
    user: {
      sFaceIcon: '',
      sNickname: '',
    },
  },
  user: {
    qbid: '',
    head: '',
    nickname: '',
    type: -1,
    uin: '',
    qbUserType: -1,
    welfareInfo: {
      taskStart: false,
    },
    guid: '',
    subscriptions: [],
  },
  postInfo: {
    postId: '',
    circleId: '',
    valid: true,
    praised: false,
  },
  article: {
    url: '',
    correlatedNews: [],
    relatedTags: [],
    docId: '',
    title: '',
    contentFields: [],
    from: '',
    time: '',
    thumbs: [],
    guideTab: {},
    stSnapInfo: {},
    contentHeight: 0,
    tags: [],
    bInnerGuid: false,
    // fusionId: 'q_13176885452_1499873055157370'
    readingUsers: 0,
    feedbacks: {},
  },
  location: {
    pathname: '',
    query: {
      extenddata: '',
    },
  },
  currentChannel: '',
  title: '',
  apn: '',
  hotComments: [],
  allComments: { items: [] },
  allAnswers: { items: [] },
  apps: {
    isOtherFt: false,
  },
  accuseModal: { show: false },
  grayConfig: {},
  honorInfoEx: {
    kolInfos: {},
    honorInfos: {},
  },
  ua: '',
  commentV2: {},
  miniProgram: {},
  videoList: {},
};

export type Thunk<A> = ((Dispatch, GetState) => Promise<void> | void) => A;

export type Reducer = (State, Action) => State;
export type Store = ReduxStore<State, Action>;
export type GetState = () => State;
export type Dispatch = ReduxDispatch<Action> & Thunk<Action>;
